<template>
  <div class="privacy-policy">
      <h1>Deadgate — Privacy Policy</h1>
      <p class="last-updated"><strong>Effective date:</strong> October 10, 2026</p>

      <p>
        This policy explains what information the mobile game <b>Deadgate</b>
        ("the game", "we", "us") handles, why, and the choices you have. The game
        is published on Google Play under the package name
        <code>com.lalen.deadgate</code>.
      </p>

      <hr />

      <h2>Summary</h2>
      <ul>
        <li>
          The game has <strong>no accounts</strong> and <strong>no servers of our
          own</strong>. We do not ask for your name, email, location, contacts or
          photos.
        </li>
        <li>Your progress is saved <strong>only on your device</strong>.</li>
        <li>
          The game uses <strong>Google Play Billing</strong> (through Unity In-App
          Purchasing) for optional purchases, and <strong>Google AdMob</strong> for
          ads, together with Google's consent tool. These services, run by Google
          and Unity, process some device and usage data as described below.
        </li>
      </ul>

      <hr />

      <h2>Information stored on your device</h2>
      <p>
        Your campaign progress, settings and the items you own are saved in the
        game's private storage on your device. This data never leaves your device
        through us. Uninstalling the game, or using
        <strong>Settings &gt; Reset Progress</strong>, deletes it (purchases stay
        with your Google account and can be restored).
      </p>

      <hr />

      <h2>Purchases (Google Play Billing, Unity In-App Purchasing)</h2>
      <p>
        Optional purchases (cosmetic looks, the Supporter Pack, removal of forced
        ads) are handled by <strong>Google Play</strong>. Your payment details are
        entered in Google Play and are never shared with us. When you buy or
        restore an item, the game receives a confirmation of the purchase
        (product, order and purchase token) from Google Play so it can unlock the
        item, and stores the result on your device. The purchase flow uses
        <strong>Unity In-App Purchasing</strong>, a software library from Unity
        Technologies, which may process technical information about the
        transaction and your device to make purchases work.
      </p>
      <ul>
        <li>
          Google Privacy Policy:
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a>
        </li>
        <li>
          Unity Privacy Policy:
          <a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener">https://unity.com/legal/privacy-policy</a>
        </li>
      </ul>

      <hr />

      <h2>Ads (Google AdMob)</h2>
      <p>
        The game may show ads served by <strong>Google AdMob</strong>: optional
        rewarded videos (you choose to watch one for a small in-game reward) and
        occasional full-screen ads between days. To serve and measure ads, prevent
        fraud and limit how often you see them, the Google Mobile Ads SDK may
        collect information such as your device's <strong>advertising ID</strong>,
        IP address, device and app information, ad interactions and diagnostic
        data, and may share it with Google and its advertising partners.
      </p>
      <ul>
        <li>
          <strong>Consent:</strong> where the law requires it (for example in the
          European Economic Area, the UK and Switzerland), the game shows Google's
          consent form before any ad is requested. You can change your choice at
          any time in <strong>Settings &gt; Privacy &gt; AD CHOICES</strong>.
        </li>
        <li>
          <strong>Personalised ads:</strong> you can reset or delete your
          advertising ID, or opt out of ads personalisation, in your Android device
          settings (Settings &gt; Google &gt; Ads, or Settings &gt; Privacy &gt;
          Ads, depending on the device).
        </li>
        <li>
          Players who own the <strong>Remove Forced Ads</strong> or
          <strong>Supporter Pack</strong> purchase do not see the full-screen ads;
          rewarded videos stay optional.
        </li>
        <li>
          How Google uses data from apps that use its services:
          <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">https://policies.google.com/technologies/partner-sites</a>
        </li>
      </ul>

      <hr />

      <h2>Analytics</h2>
      <p>
        The released game does not include an analytics service of our own and
        does not send gameplay data to us.
      </p>

      <hr />

      <h2>Children</h2>
      <p>
        Deadgate contains fantasy violence against zombies and is
        <strong>not directed at children under 13</strong>. We do not knowingly
        collect personal information from children. If you believe a child has
        provided personal information through the game, contact us and we will
        help remove it.
      </p>

      <hr />

      <h2>Data retention and your rights</h2>
      <p>
        We do not hold personal data about you on any server, so there is nothing
        for us to export or delete beyond the data on your device, which you
        control. Data processed by Google or Unity is governed by their privacy
        policies, where you can exercise your rights (access, deletion,
        objection). Depending on where you live (for example under the GDPR or US
        state privacy laws), you may have additional rights; contact us and we
        will help you with any request related to the game.
      </p>

      <hr />

      <h2>Security</h2>
      <p>
        Data on your device is stored in the game's private storage, which other
        apps cannot read. The Google and Unity services used by the game encrypt
        data in transit.
      </p>

      <hr />

      <h2>Changes to this policy</h2>
      <p>
        If the game starts handling information in a new way, we will update this
        page and its effective date before the change takes effect.
      </p>

      <hr />

      <h2>Contact</h2>
      <p>
        Questions or requests about privacy:
        <a href="mailto:chayanutp39@gmail.com">chayanutp39@gmail.com</a>
      </p>
    </div>
</template>

<script>
export default {
  name: 'DeadgatePrivacyPolicy'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.privacy-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    line-height: 1.6;
    text-align: left;

    color: white;
    background-color: #252525;
    font-family: sans-serif;
  }
h1 {
  text-align: center;
}
.last-updated {
  text-align: center;
  color: #bbb;
}
li {
  margin: 0.35rem 0;
}
a {
  color: #42b983;
  word-break: break-word;
}
</style>
